export default defineNuxtPlugin(async () => {
    const pdfSource = usePdfPreview()
    const hanldePdfLinkClick = (e: Event, link: HTMLAnchorElement) => {
        e.preventDefault()
        pdfSource.value = link.href
    }

    const anchors = document.querySelectorAll('a')
    const pdfLinks = Array.from(anchors).filter((a) => a.href.endsWith('.pdf'))
    pdfLinks.forEach((link) => {
        if(link.dataset?.previewDisabled === 'true') return
        link.addEventListener('click', (e) => hanldePdfLinkClick(e, link))
        link.setAttribute('aria-label', `Otvoriť PDF ${link.textContent}`)
        link.setAttribute('role', 'button')
        link.setAttribute('aria-expanded', 'false')
    })
})
